import React from 'react'
// TODO move ui
// import { Section, Message, Heading, Text, LayoutContent } from '@brainstud/schiphol-vtc-ui'
import { leadingZero } from '@brainstud/react-helpers'

const NoTemplateRows = props => (
  // <Section>
  //   <Heading h1>{props.lesson.title}</Heading>
  //
  //   <Message>
      <div>No template found in content/chapters/{leadingZero(props.chapter.prefix)}/{leadingZero(props.lesson.prefix)}/Lesson.js</div>
  //   </Message>
  // </Section>
)

const NoTemplateCols = props => (
  <LayoutContent main={
    <Section>
      <Heading h1>{props.lesson.title}</Heading>

      <Message>
        <Text>No template found in content/chapters/{leadingZero(props.chapter.prefix)}/{leadingZero(props.lesson.prefix)}/Lesson.js</Text>
      </Message>
    </Section>
  } widget={<div />} />
)

const types = {
  rows: NoTemplateRows,
  cols: NoTemplateCols,
}

const NoTemplate = props => {
  const Tpl = types[props.lesson.type || 'rows']
  return <Tpl {...props} />
}

export default NoTemplate
